import React, { createContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import useWebSocket from 'granite-admin/utils/useWebSocket';
import useWebSocketIO from 'granite-admin/utils/useWebSocketIO';
const ConfigContext = /*#__PURE__*/createContext();
const ConfigProvider = ({
  config,
  children
}) => {
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const {
    loadWebsocketInstance
  } = useWebSocket();
  const {
    loadWebsocketInstance: loadWebsocketInstanceIO
  } = useWebSocketIO();
  useEffect(() => {
    const subscription = grandEmitter.getObservable().subscribe(event => {
      switch (event.type) {
        case 'LOAD_WEBSOCKET':
          loadWebsocketInstanceIO();
          loadWebsocketInstance();
          break;
        default:
          break;
      }
    });
    return () => subscription.unsubscribe();
  }, [grandEmitter, loadWebsocketInstance, loadWebsocketInstanceIO]);
  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: config
  }, children);
};
ConfigProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.node])
};
export { ConfigProvider, ConfigContext };